(function() {
    'use strict';

    angular
        .module('teJHipsterApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider
        .state('handbook-version', {
            parent: 'entity',
            url: '/handbook-version?page&sort&search',
            data: {
                authorities: ['ROLE_USER'],
                pageTitle: 'teJHipsterApp.handbookVersion.home.title'
            },
            views: {
                'content@': {
                    templateUrl: 'app/entities/handbook-version/handbook-versions.html',
                    controller: 'HandbookVersionController',
                    controllerAs: 'vm'
                }
            },
            params: {
                page: {
                    value: '1',
                    squash: true
                },
                sort: {
                    value: 'id,asc',
                    squash: true
                },
                search: null
            },
            resolve: {
                pagingParams: ['$stateParams', 'PaginationUtil', function ($stateParams, PaginationUtil) {
                    return {
                        page: PaginationUtil.parsePage($stateParams.page),
                        sort: $stateParams.sort,
                        predicate: PaginationUtil.parsePredicate($stateParams.sort),
                        ascending: PaginationUtil.parseAscending($stateParams.sort),
                        search: $stateParams.search
                    };
                }],
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('handbookVersion');
                    $translatePartialLoader.addPart('handbookVersionState');
                    $translatePartialLoader.addPart('global');
                    return $translate.refresh();
                }]
            }
        })
        .state('handbook-version-detail', {
            parent: 'handbook-version',
            url: '/handbook-version/{id}',
            data: {
                authorities: ['ROLE_USER'],
                pageTitle: 'teJHipsterApp.handbookVersion.detail.title'
            },
            views: {
                'content@': {
                    templateUrl: 'app/entities/handbook-version/handbook-version-detail.html',
                    controller: 'HandbookVersionDetailController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('handbookVersion');
                    $translatePartialLoader.addPart('handbookVersionState');
                    return $translate.refresh();
                }],
                entity: ['$stateParams', 'HandbookVersion', function($stateParams, HandbookVersion) {
                    return HandbookVersion.get({id : $stateParams.id}).$promise;
                }],
                previousState: ["$state", function ($state) {
                    var currentStateData = {
                        name: $state.current.name || 'handbook-version',
                        params: $state.params,
                        url: $state.href($state.current.name, $state.params)
                    };
                    return currentStateData;
                }]
            }
        })
        .state('handbook-version-detail.edit', {
            parent: 'handbook-version-detail',
            url: '/detail/edit',
            data: {
                authorities: ['ROLE_USER']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/handbook-version/handbook-version-dialog.html',
                    controller: 'HandbookVersionDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: ['HandbookVersion', function(HandbookVersion) {
                            return HandbookVersion.get({id : $stateParams.id}).$promise;
                        }]
                    }
                }).result.then(function() {
                    $state.go('^', {}, { reload: false });
                }, function() {
                    $state.go('^');
                });
            }]
        })
        .state('handbook-version.new', {
            parent: 'handbook-version',
            url: '/new',
            data: {
                authorities: ['ROLE_USER']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/handbook-version/handbook-version-dialog.html',
                    controller: 'HandbookVersionDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: function () {
                            return {
                                version: null,
                                validFrom: null,
                                validUntil: null,
                                publicationDate: null,
                                state: null,
                                significantChange: false,
                                note: null,
                                creationTime: null,
                                revisionTime: null,
                                id: null
                            };
                        }
                    }
                }).result.then(function() {
                    $state.go('handbook-version', null, { reload: 'handbook-version' });
                }, function() {
                    $state.go('handbook-version');
                });
            }]
        })
        .state('handbook-version.edit', {
            parent: 'handbook-version',
            url: '/{id}/edit',
            data: {
                authorities: ['ROLE_USER']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/handbook-version/handbook-version-dialog.html',
                    controller: 'HandbookVersionDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: ['HandbookVersion', function(HandbookVersion) {
                            return HandbookVersion.get({id : $stateParams.id}).$promise;
                        }]
                    }
                }).result.then(function() {
                    $state.go('handbook-version', null, { reload: 'handbook-version' });
                }, function() {
                    $state.go('^');
                });
            }]
        })
        .state('handbook-version.delete', {
            parent: 'handbook-version',
            url: '/{id}/delete',
            data: {
                authorities: ['ROLE_USER']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/handbook-version/handbook-version-delete-dialog.html',
                    controller: 'HandbookVersionDeleteController',
                    controllerAs: 'vm',
                    size: 'md',
                    resolve: {
                        entity: ['HandbookVersion', function(HandbookVersion) {
                            return HandbookVersion.get({id : $stateParams.id}).$promise;
                        }]
                    }
                }).result.then(function() {
                    $state.go('handbook-version', null, { reload: 'handbook-version' });
                }, function() {
                    $state.go('^');
                });
            }]
        });
    }

})();
